import { Component, OnInit, ElementRef, ViewChild, QueryList, ViewChildren, AfterViewInit, HostListener } from '@angular/core';
import { GlobalService } from '../../services/global/global.service';
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss']
})
export class AboutComponent implements OnInit {
  url = this.global.mediasUrl;
  constructor(private global: GlobalService, private elRef: ElementRef) {}

  nums: Array<number> = [25, 76, 48];
  view: boolean = false
  @ViewChild("oneItem") oneItem: any;
  @ViewChildren("count") count: QueryList<any>;
  @HostListener('window:scroll', ['$event'])
  onWindowScroll($event) {
    if (window.pageYOffset > 5000) {
      this.view = true
    }
    else {
      this.view = false
    }
  }
  ngOnInit() {
    // window.addEventListener('scroll', this.onScroll, true);
  }

  // ngAfterViewInit() {
  //   this.animateCount();
  // }

  // onScroll(event) {
  //   if (window.pageYOffset > 1) {
  //     this.view = true
  //   }
  //   else {
  //     this.view = false
  //   }
  // }

  animateCount() {
    let _this = this;

    let single = this.oneItem.nativeElement.innerHTML;

    this.counterFunc(single, this.oneItem, 7000);

    this.count.forEach(item => {
      _this.counterFunc(item.nativeElement.innerHTML, item, 2000);
    });
  }

  counterFunc(end: number, element: any, duration: number) {
    let range, current: number, step, timer;

    range = end - 0;
    current = 0;
    step = Math.abs(Math.floor(duration / range));

    timer = setInterval(() => {
      current += 1;
      element.nativeElement.textContent = current;
      if (current == end) {
        clearInterval(timer);
      }
    }, step);
  }

}
